import React from 'react';
import {observer} from 'mobx-react';
import {ObjectSelect2, FormLayout, FormError, DatePicker} from 'shared/components';
import {withState, t} from 'shared/core';
import {Spinner} from 'shared/components';
import {AddRevieweeState} from '../state';
import {ModalButtons} from 'shared/components/modals';
import {auth} from 'main/tools';

const LoadingState = observer(({isOpen}) => {
  return (
    <div className='height-400'>
      <Spinner/>
    </div>
  );
});


const SelectReviewee = observer(({uiState}) => {
  const {selectedReviewee, revieweeEmployees} = uiState;

  return (
    <ObjectSelect2
      label='performance_reviews.manage.Reviewee'
      items={revieweeEmployees}
      value={selectedReviewee.employee}
      onChange={revieweeEmployee => uiState.updateReviewee(revieweeEmployee)}
      placeholder='performance_reviews.manage.Add participant'
      searchable
      allowClear
    />
  );
});

const SelectManager = observer(({uiState}) => {
  const {selectedReviewee, employees} = uiState;

  if (!selectedReviewee.employee) return null;

  return (
    <ObjectSelect2
      label='performance_reviews.manage.Manager reviewer'
      helpLink={{
        title: t('components.help_link.Who is this?'),
        explanation: {
          header: 'performance_reviews.manage.MANAGER_HELP_HEADER',
          paragraphs: [
            t('performance_reviews.manage.MANAGER_HELP_DESC_1'),
            t('performance_reviews.manage.MANAGER_HELP_DESC_2'),
            t('performance_reviews.manage.MANAGER_HELP_DESC_3')
          ]
        }
      }}
      items={employees}
      value={selectedReviewee.reviewManager}
      onAdd={manager => uiState.addManager(manager)}
      onRemove={manager => uiState.removeManager(manager)}
      onChange={manager => uiState.updateManagerReviewer(manager)}
      multiple={auth.featureEnabled(':multiple_review_managers')}
      searchable
      allowClear
    />
  );
});

const SelectPeers = observer(({uiState}) => {
  const {selectedReviewee, cycle, employees, selectedPeers} = uiState;

  if (!cycle.peerType || !selectedReviewee.employee) return null;

  return (
    <ObjectSelect2
      label='performance_reviews.manage.Peer reviewers'
      items={employees}
      value={selectedPeers}
      onAdd={peer => uiState.addPeer(peer)}
      onRemove={peer => uiState.removePeer(peer)}
      placeholder='performance_reviews.manage.Add peer'
      multiple
    />
  );
});

const AddReviewee = observer(({uiState}) => {
  const {selectedReviewee, errors} = uiState;

  return (
    <div>
      <FormLayout>
        <SelectReviewee uiState={uiState}/>
        <SelectManager uiState={uiState}/>
        <SelectPeers uiState={uiState}/>
        {selectedReviewee.employee && <DatePicker
          className='full-width'
          label='performance_reviews.manage.Launch date'
          onChange={date => selectedReviewee.launchDate = date}
          value={selectedReviewee.launchDate}
        />}
        {selectedReviewee.employee && <DatePicker
          className='full-width'
          label='performance_reviews.manage.Due date'
          onChange={date => selectedReviewee.dueDate = date}
          value={selectedReviewee.dueDate}
          errorMessage={errors.dueDate}
        />}
        <FormError message={errors.base}/>
      </FormLayout>
      <ModalButtons onCancel={uiState.onHide} onSave={() => uiState.saveReviewee()}/>
    </div>
  );
});

export default withState(
  AddReviewee,
  AddRevieweeState,
  {
    spinner: LoadingState
  }
);
